exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-easymde .markdown-body {\n  padding: 0.5em\n}\n.vue-easymde .editor-preview-active, .vue-easymde .editor-preview-active-side {\n  display: block;\n}\n", ""]);

// exports
